import { createStyles } from '../../../../../../styles/helpers'

import { lightOrange } from '../../../../../../styles/const/colors'
import { expandRowLeftPadding, rowLeftPadding, tableBorderColor } from '../../../../../../components/Table/styles'
import { subTable } from '../../../../../../styles/common/table'

const useStyles = createStyles({
  notUploadedRow: {
    backgroundColor: lightOrange
  },
  uploadedFilesTable: {
    extend: subTable,
    borderTop: `1px solid ${tableBorderColor}`,
    paddingLeft: expandRowLeftPadding - rowLeftPadding + 15 // align + add indent to the sub table rows with the parent table
  },
  uploadedFilesTableRow: {
    border: 'none !important'
  }
})

export default useStyles
